import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, Fragment as _Fragment, createSlots as _createSlots, vShow as _vShow, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/close_circle.svg'
import _imports_1 from '@/app/ui/assets/svg/check-circle.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-90e7bf5e")

_pushScopeId("data-v-90e7bf5e")
const _hoisted_1 = { class: "account h-full overflow-auto" }
const _hoisted_2 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  id: "otp-verification"
}
const _hoisted_5 = { class: "font-semibold text-12px xxl:text-14px text-gray-lp-300 mb-4" }
const _hoisted_6 = {
  key: 0,
  class: "inline-flex items-center px-4 py-2 rounded-full bg-red-lp-1300 text-red-lp-100 text-12px xxl:text-14px font-semibold mb-4"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "lp-icon-close",
  class: "w-4 h-4 mr-2"
}, null, -1)
const _hoisted_8 = {
  key: 1,
  class: "inline-flex items-center px-4 py-2 rounded-full bg-green-lp-300 text-green-lp-400 text-12px xxl:text-14px font-semibold mb-4"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "lp-icon-check",
  class: "w-4 h-4 mr-2"
}, null, -1)
const _hoisted_10 = { class: "text-12px xxl:text-14px text-gray-lp-500 mb-6" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 2,
  class: "flex pb-1"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "py-1" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_15 = { id: "change-password" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-12px xxl:text-14px text-gray-lp-300 mb-6" }, " Password ", -1)
const _hoisted_17 = { class: "flex pb-1" }
const _hoisted_18 = {
  id: "logout",
  class: "pt-6 border-t border-gray-lp-400 isScroll"
}
const _hoisted_19 = { class: "font-semibold text-12px xxl:text-14px text-gray-lp-300" }
const _hoisted_20 = { class: "flex flex-row mt-2 mb-6 text-12px text-gray-lp-500" }
const _hoisted_21 = {
  key: 0,
  class: "loader rounded-full border-2 border-t-1 h-5 w-5 mx-auto"
}
const _hoisted_22 = { key: 1 }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "py-1" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_user_profile_section = _resolveComponent("user-profile-section")!
  const _component_data_account_section = _resolveComponent("data-account-section")!
  const _component_device_auth_section = _resolveComponent("device-auth-section")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_Logout = _resolveComponent("Logout")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_ModalChangePassword = _resolveComponent("ModalChangePassword")!
  const _component_ModalChangeEmail = _resolveComponent("ModalChangeEmail")!
  const _component_ModalOtp = _resolveComponent("ModalOtp")!
  const _component_QRCodeProfile = _resolveComponent("QRCodeProfile")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_DetailLayout, {
        "display-back": false,
        loading: _ctx.isLoading || _ctx.isLoadingAccount,
        error: _ctx.isErrorInternetOrSystem,
        errorType: _ctx.errorCause,
        onTryAgain: _ctx.fetchDataProfile,
        title: _ctx.$t(_ctx.getCurrentRoute)
      }, _createSlots({
        "sub-data": _withId(() => [
          (_ctx.isEligibleSetupOtp && _ctx.isLogin2FaEnable)
            ? (_openBlock(), _createBlock("div", _hoisted_4, [
                _createVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("authenticator.profile.title")), 1),
                (_ctx.showMfaEnrollmentAlert)
                  ? (_openBlock(), _createBlock("div", _hoisted_6, [
                      _hoisted_7,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("authenticator.profile.statusNotActive")), 1)
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_8, [
                      _hoisted_9,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("authenticator.profile.statusActive")), 1)
                    ])),
                _createVNode("div", _hoisted_10, [
                  (_ctx.showMfaEnrollmentAlert)
                    ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_11, null, 512)), [
                        [_directive_sanitize_html, _ctx.$t('authenticator.profile.notEnrolled')]
                      ])
                    : _withDirectives((_openBlock(), _createBlock("div", _hoisted_12, null, 512)), [
                        [_directive_sanitize_html, _ctx.$t('authenticator.profile.enrolled')]
                      ])
                ]),
                (_ctx.showMfaEnrollmentAlert)
                  ? (_openBlock(), _createBlock("div", _hoisted_13, [
                      _createVNode(_component_lp_button, {
                        onClick: _ctx.goToMfaVerifyOtp,
                        outline: "",
                        "text-color": "red-lp-100",
                        color: "red-lp-100",
                        title: _ctx.$t('authenticator.profile.buttonText')
                      }, null, 8, ["onClick", "title"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _hoisted_14,
          _createVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode("div", _hoisted_17, [
              _createVNode(_component_lp_button, {
                onClick: _ctx.openModalChangePassword,
                outline: "",
                "text-color": "red-lp-100",
                color: "red-lp-100",
                title: _ctx.$t('Ubah Password')
              }, null, 8, ["onClick", "title"])
            ])
          ]),
          _createVNode("div", _hoisted_18, [
            _createVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("profile.logout")), 1),
            _createVNode("div", _hoisted_20, _toDisplayString(_ctx.$t(
                "Sebelum keluar silahkan pastikan kembali tidak ada aktivitas yang sedang berjalan."
              )), 1),
            _createVNode("button", {
              type: "submit",
              onClick: _ctx.onOpenLogout,
              class: "text-white px-8 py-3 text-12px xxl:text-14px font-bold rounded-md focus:outline-none bg-red-lp-300 flex flex-row"
            }, [
              (_ctx.isLoading)
                ? (_openBlock(), _createBlock("div", _hoisted_21))
                : _createCommentVNode("", true),
              _createVNode(_component_Logout, { class: "w-5 mr-3" }),
              (!_ctx.isLoading)
                ? (_openBlock(), _createBlock("span", _hoisted_22, _toDisplayString(_ctx.$t("profile.logout")), 1))
                : _createCommentVNode("", true)
            ], 8, ["onClick"])
          ]),
          (_ctx.partnerDetail.roleType)
            ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                _hoisted_23,
                _createVNode(_component_DataWrapper, { label: "QR Code" }, {
                  default: _withId(() => [
                    _createVNode(_component_LpButton, {
                      onClick: _ctx.downloadQRCode,
                      class: "mt-3 w-48",
                      flat: "",
                      dense: "",
                      iconLeft: "qrcode",
                      title: "Download QR Code",
                      textColor: "gray-lp-600"
                    }, null, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, [
        (!_ctx.isLoading)
          ? {
              name: "data",
              fn: _withId(() => [
                _createVNode(_component_user_profile_section, { onChangeEmail: _ctx.openModalChangeEmail }, null, 8, ["onChangeEmail"]),
                _hoisted_2,
                _createVNode(_component_data_account_section),
                (_ctx.listDeviceAuth.length && !_ctx.isSenderDashboard)
                  ? (_openBlock(), _createBlock("hr", _hoisted_3))
                  : _createCommentVNode("", true),
                (_ctx.listDeviceAuth.length && !_ctx.isSenderDashboard)
                  ? (_openBlock(), _createBlock(_component_device_auth_section, {
                      key: 1,
                      class: "pb-6",
                      modelValue: _ctx.listDeviceAuth,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.listDeviceAuth = $event))
                    }, null, 8, ["modelValue"]))
                  : _createCommentVNode("", true)
              ])
            }
          : undefined
      ]), 1032, ["loading", "error", "errorType", "onTryAgain", "title"])
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onClose: _ctx.dialogData?.onClose,
      onSubmit: _ctx.dialogData?.onSuccess,
      title: _ctx.dialogData.title,
      message: _ctx.dialogData.message,
      image: _ctx.dialogData.image,
      textCancel: _ctx.dialogData.textClose,
      textSuccess: _ctx.dialogData.textSuccess
    }, null, 8, ["onClose", "onSubmit", "title", "message", "image", "textCancel", "textSuccess"]), [
      [_vShow, _ctx.isOpenModal || _ctx.isSenderChangePassword]
    ]),
    _withDirectives(_createVNode(_component_ErrorMessage, {
      errorType: _ctx.errorCauseLogout,
      modal: "",
      onCancel: _ctx.handleCloseError,
      onTryAgain: _ctx.onSubmitLogout
    }, null, 8, ["errorType", "onCancel", "onTryAgain"]), [
      [_vShow, _ctx.isErrorInternetOrSystemLogout]
    ]),
    _createVNode(_component_ModalChangePassword, {
      ref: "modal-change-password",
      modelValue: _ctx.modalChangePassword,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.modalChangePassword = $event)),
      onOpenOtp: _ctx.onOpenOtp,
      onErrorRequestOtp: _ctx.onUpdateOpenOtp
    }, null, 8, ["modelValue", "onOpenOtp", "onErrorRequestOtp"]),
    (_ctx.modalChangeEmail || _ctx.modalChangeEmailPassword)
      ? (_openBlock(), _createBlock(_component_ModalChangeEmail, {
          key: 0,
          modelValue: _ctx.modalChangeEmail,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.modalChangeEmail = $event)),
          "model-value-password": _ctx.modalChangeEmailPassword,
          "current-email": _ctx.dataProfile.email,
          "is-change-email-wizard-enabled": _ctx.isChangeEmailWizardEnabled,
          "onUpdate:modelValuePassword": _cache[4] || (_cache[4] = ($event: any) => (_ctx.modalChangeEmailPassword = $event)),
          onSubmitNewEmail: _ctx.onSubmitNewEmail,
          onSubmitLegacyEmail: _ctx.onSubmitLegacyEmail,
          onPasswordConfirmed: _ctx.onPasswordConfirmedEmail,
          onClose: _ctx.onCloseChangeEmailWizard
        }, null, 8, ["modelValue", "model-value-password", "current-email", "is-change-email-wizard-enabled", "onSubmitNewEmail", "onSubmitLegacyEmail", "onPasswordConfirmed", "onClose"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ModalOtp, {
      modelValue: _ctx.showChangeEmailOtpModal,
      "onUpdate:modelValue": [
        _cache[5] || (_cache[5] = ($event: any) => (_ctx.showChangeEmailOtpModal = $event)),
        _ctx.onCloseChangeEmailOtp
      ],
      email: _ctx.changeEmailMaskedEmail,
      newEmail: _ctx.newEmailChange,
      password: _ctx.changeEmailPassword,
      action: 'change_email',
      isWithContacts: "",
      onVerify: _ctx.onVerifyChangeEmailOtp
    }, null, 8, ["modelValue", "onUpdate:modelValue", "email", "newEmail", "password", "onVerify"]),
    _createVNode(_component_QRCodeProfile, {
      "partner-id": _ctx.partnerDetail.id,
      "partner-name": _ctx.partnerDetail.name,
      "partner-address": _ctx.partnerDetail.address,
      ref: "qrcodeProfile"
    }, null, 8, ["partner-id", "partner-name", "partner-address"]),
    _createVNode(_component_ModalOtp, {
      modelValue: _ctx.openOtp,
      "onUpdate:modelValue": [
        _cache[6] || (_cache[6] = ($event: any) => (_ctx.openOtp = $event)),
        _ctx.onUpdateOpenOtp
      ],
      email: _ctx.emailUser,
      phone: _ctx.phoneUser,
      password: _ctx.otpData.password,
      action: _ctx.otpData.action,
      onVerify: _ctx.onEditPassword
    }, null, 8, ["modelValue", "onUpdate:modelValue", "email", "phone", "password", "action", "onVerify"])
  ], 64))
})